import Api from '../base/index.js'

export default{
    async update(id, data){
        return Api.put(`exam-subject-score/${id}`, data)
    },
}